// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';
const lightbox = GLightbox({
	plyr: {
		config: {
			loadSprite: false,
			storage: {
				enabled: false,
			},
		},
	},
});

$(document).ready(function () {
	// const sharebox = GLightbox({
	//     skin: "sharebox",
	//     selector: ".glightbox-share",
	//     touchNavigation: false,
	//     touchFollowAxis: false,
	//     keyboardNavigation: false,
	//     zoomable: false,
	//     draggable: false,
	//     // width: '60vw',
	//     height: 'auto'
	// });

	// $('.close-popup').click(function(e){
	//     e.preventDefault();
	//     console.log("close popup");
	//     sharebox.close();
	// })

	if ($('.searchboxlink').length) {
		const searchbox = GLightbox({
			/*touchNavigation: false,
          touchFollowAxis: false,
          keyboardNavigation: false,*/
			selector: '.searchboxlink',
			zoomable: false,
			draggable: false,
			// width: '60vw',
			height: 'auto',
			autoplayVideos: true,
		});

		searchbox.on('open', () => {
			$('.button--close').click(function () {
				searchbox.close();
			});
			setTimeout(function () {
				var searchfield = $('#glightbox-body #search form.search--form input.search-input');
				$($(searchfield)[0]).focus();
			}, 300);
		});
	}

	if ($('.openmodal').length) {
		const infomodal = GLightbox({
			selector: '.openmodal',
			zoomable: false,
			draggable: false,
			height: 'auto',
		});
		infomodal.on('open', () => {
			$('.button--close').click(function () {
				infomodal.close();
			});
		});
	}
});
